module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-input-wrapper"
  }, [_c('ul', {
    staticClass: "progress-boxs gutter-12 clearfix",
    attrs: {
      "id": "buttons-tab"
    }
  }, [_c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 1
    }
  }, [_c('a', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_c('label', [_vm._v("1. 기본정보")]), (_vm.step === 1) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e(), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 2
    }
  }, [_c('a', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_c('label', [_vm._v("2. 강좌정보")]), (_vm.step === 2) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e(), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 3
    }
  }, [_c('a', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_c('label', [_vm._v("3. 등록")]), (_vm.step === 3) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e()])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('h2', {
    staticClass: "basic-form-title"
  }, [_vm._v("1. 기본정보")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "loginid"
    }
  }, [_vm._v("아이디")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text",
    attrs: {
      "id": "loginid"
    }
  }, [_vm._v(_vm._s(_vm.member.loginid))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "realname"
    }
  }, [_vm._v("이름(본명)")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text",
    attrs: {
      "id": "realname"
    }
  }, [_vm._v(_vm._s(_vm.member.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "email1"
    }
  }, [_vm._v("이메일")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email1),
      expression: "email1"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "id": "email1",
      "placeholder": "입력해주세요",
      "title": "email 계정입력"
    },
    domProps: {
      "value": (_vm.email1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-10 text-center"
  }, [_vm._v("@")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email2),
      expression: "email2"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "emailSelectBox",
      "title": "email 도메인 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.email2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.emailChange]
    }
  }, [_vm._l((_vm.emailList), function(list) {
    return _c('option', {
      domProps: {
        "value": list
      }
    }, [_vm._v(_vm._s(list))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("직접입력")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.etcEmailAddress),
      expression: "etcEmailAddress"
    }],
    staticClass: "input__text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "",
      "id": "emailSelectBoxDirect",
      "placeholder": "입력해주세요",
      "title": "email 도메인 직접입력"
    },
    domProps: {
      "value": (_vm.etcEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.etcEmailAddress = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "phone1"
    }
  }, [_vm._v("휴대폰")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10",
    attrs: {
      "id": "phone1"
    }
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-3--xs"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.phone1),
      expression: "member.phone1"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "phone1",
      "title": "휴대폰 앞자리 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.member, "phone1", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "010"
    }
  }, [_vm._v("010")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "011"
    }
  }, [_vm._v("011")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "016"
    }
  }, [_vm._v("016")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "017"
    }
  }, [_vm._v("017")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "018"
    }
  }, [_vm._v("018")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "019"
    }
  }, [_vm._v("019")])])]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-3--xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.phone2),
      expression: "member.phone2"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "입력해주세요",
      "title": "휴대폰 가운데자리 입력"
    },
    domProps: {
      "value": (_vm.member.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "phone2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-3--xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.phone3),
      expression: "member.phone3"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "입력해주세요",
      "title": "휴대폰 끝자리 입력"
    },
    domProps: {
      "value": (_vm.member.phone3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "phone3", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "findPostCode"
    }
  }, [_vm._v("주소")]), _vm._v(" "), _c('div', {
    staticClass: "address-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.zipcode),
      expression: "member.zipcode"
    }],
    staticClass: "input__text input__text--readonly",
    attrs: {
      "type": "text",
      "id": "findPostCode",
      "readonly": "",
      "title": "우편번호 입력"
    },
    domProps: {
      "value": (_vm.member.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "zipcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "address-input-group__btn",
    on: {
      "click": _vm.findAddress
    }
  }, [_vm._v("주소검색")])]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li"
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "border": "1px solid",
      "width": "500px",
      "height": "300px",
      "margin": "5px 0",
      "position": "relative",
      "overflow": "hidden"
    },
    attrs: {
      "id": "wrap"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "wrapTab"
    }
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer",
      "position": "absolute",
      "right": "5px",
      "top": "50px",
      "z-index": "1",
      "outline-color": "red"
    },
    attrs: {
      "src": "//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png",
      "id": "btnFoldWrap",
      "alt": "접기 버튼",
      "tabIndex": "0"
    },
    on: {
      "click": _vm.foldDaumPostcode,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.foldDaumPostcodeEnter.apply(null, arguments)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.addr1),
      expression: "member.addr1"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "입력해주세요",
      "title": "주소",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.member.addr1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "addr1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.addr2),
      expression: "member.addr2"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "입력해주세요",
      "title": "상세주소 입력"
    },
    domProps: {
      "value": (_vm.member.addr2)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.member, "addr2", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('p', {
    staticClass: "inline-input__label"
  }, [_vm._v("성별")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "formen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.gender),
      expression: "member.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "formen",
      "value": "M",
      "title": "남자체크"
    },
    domProps: {
      "checked": _vm._q(_vm.member.gender, "M")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.member, "gender", "M")
      }
    }
  }), _vm._v(" 남자\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "forwomen"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member.gender),
      expression: "member.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "forwomen",
      "value": "F",
      "title": "여자체크"
    },
    domProps: {
      "checked": _vm._q(_vm.member.gender, "F")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.member, "gender", "F")
      }
    }
  }), _vm._v(" 여자\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("생년월일")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10"
  }, [_c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthYear),
      expression: "birthYear"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "number",
      "name": "",
      "id": "birthdate",
      "title": "birthdate 입력"
    },
    domProps: {
      "value": (_vm.birthYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.birthYear = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthMonth),
      expression: "birthMonth"
    }],
    staticClass: "input__select",
    attrs: {
      "title": "월선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("1월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("2월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("3월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("4월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("5월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("6월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("7월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("8월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("9월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11월")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12월")])])]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthDay),
      expression: "birthDay"
    }],
    staticClass: "input__select gutter-10__li grid-3",
    attrs: {
      "title": "일선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthDay = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("1일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("2일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("3일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("4일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("5일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("6일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("7일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("8일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("9일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("13일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("14일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("16일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("17일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("19일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("21일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("22일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("23일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "26"
    }
  }, [_vm._v("26일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v("27일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "28"
    }
  }, [_vm._v("28일")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "29"
    }
  }, [_vm._v("29일")]), _vm._v(" "), (_vm.birthMonth !== '02') ? _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30일")]) : _vm._e(), _vm._v(" "), (_vm.birthMonth !== '02') ? _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("31일")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "joinChannel"
    }
  }, [_vm._v("가입경로")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channel),
      expression: "channel"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "joinChannel",
      "title": "joinChannel 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.channelChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "서울시 유관홈페이지"
    }
  }, [_vm._v("서울시 유관홈페이지")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "언론보도"
    }
  }, [_vm._v("언론보도(신문, 방송, 라디오 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "홍보책자"
    }
  }, [_vm._v("홍보책자(포스터, 전단지, 리플릿 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "옥외광고"
    }
  }, [_vm._v("옥외광고(지하철, 버스, 현수막 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "미디어광고"
    }
  }, [_vm._v("미디어광고(신문잡지, 라디오광고 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "인터넷/SNS 검색"
    }
  }, [_vm._v("인터넷/SNS 검색(페이스북 등)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "타 기관 안내"
    }
  }, [_vm._v("타 기관 안내")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("기타")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelEtc),
      expression: "channelEtc"
    }],
    staticClass: "input__text margin-top-10",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "",
      "id": "joinChannelEtc",
      "placeholder": "입력해주세요.",
      "title": "가입경로 기타"
    },
    domProps: {
      "value": (_vm.channelEtc)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.channelEtc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motive),
      expression: "motive"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "joinMotive",
      "title": "joinMotive 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.motive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.motiveChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "인생후반전 준비에 대한 인식을 가지고자"
    }
  }, [_vm._v("인생후반전 준비에 대한 인식을 가지고자")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "사회공헌 및 자원봉사에 관심이 있어서"
    }
  }, [_vm._v("사회공헌 및 자원봉사에 관심이 있어서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NGO 등 인생후반전을 위한 단체를 구성하기 위해서"
    }
  }, [_vm._v("NGO 등 인생후반전을 위한 단체를 구성하기 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "창업을 위해서"
    }
  }, [_vm._v("창업을 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "재취업을 위해서"
    }
  }, [_vm._v("재취업을 위해서")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "생각이나 취미가 같은 사람들을 만나기 위해"
    }
  }, [_vm._v("생각이나 취미가 같은 사람들을 만나기 위해")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("기타")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motiveEtc),
      expression: "motiveEtc"
    }],
    staticClass: "input__text margin-top-10",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "",
      "id": "joinMotiveEtc",
      "placeholder": "입력해주세요.",
      "title": "가입동기 기타"
    },
    domProps: {
      "value": (_vm.motiveEtc)
    },
    on: {
      "keyup": _vm.checked,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motiveEtc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "myProfile"
    }
  }, [_vm._v("사진")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "formmyProfile",
      "id": "formmyProfile",
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api/file-uploads"
    }
  }, [_c('input', {
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "myProfile",
      "title": "myProfile 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange('myProfile')
      }
    }
  })]), _vm._v(" "), (_vm.member.photoUrl) ? _c('img', {
    staticClass: "file-uploads-thumb",
    attrs: {
      "src": _vm.member.photoUrl,
      "alt": "프로필 사진"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('p', {
    staticClass: "inline-input__label"
  }, [_vm._v("나의 관심 50+")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline label__radio",
    attrs: {
      "for": "like-orgs"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allCheck),
      expression: "allCheck"
    }],
    staticClass: "input__checkbox",
    attrs: {
      "type": "checkbox",
      "name": "inlineRadioOptions",
      "id": "like-orgs",
      "title": "전체 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.allCheck) ? _vm._i(_vm.allCheck, null) > -1 : (_vm.allCheck)
    },
    on: {
      "click": _vm.chkAllOrgs,
      "change": function($event) {
        var $$a = _vm.allCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allCheck = $$c
        }
      }
    }
  }), _vm._v(" 전체\n          ")]), _vm._v(" "), _vm._l((_vm.orgList), function(org) {
    return _c('label', {
      staticClass: "checkbox-inline label__radio"
    }, [(org.code !== 'fpp') ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.member.likeOrgs),
        expression: "member.likeOrgs"
      }],
      staticClass: "input__checkbox",
      attrs: {
        "type": "checkbox",
        "name": "inlineRadioOptions",
        "title": org.name
      },
      domProps: {
        "value": org.code,
        "checked": Array.isArray(_vm.member.likeOrgs) ? _vm._i(_vm.member.likeOrgs, org.code) > -1 : (_vm.member.likeOrgs)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.member.likeOrgs,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = org.code,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.member, "likeOrgs", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.member, "likeOrgs", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.member, "likeOrgs", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(org.name) + "\n            ")] : _vm._e()], 2)
  }), _vm._v(" "), _c('p', {
    staticClass: "helper-text"
  }, [_vm._v("* 관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.")])], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('p', {
    staticClass: "inline-input__label"
  }, [_vm._v(" 주된 직업군")]), _vm._v(" "), _vm._l((_vm.occuList), function(occu) {
    return _c('label', {
      staticClass: "checkbox-inline label__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.member.occuPation),
        expression: "member.occuPation"
      }],
      staticClass: "input__checkbox",
      attrs: {
        "type": "checkbox",
        "name": "occuPationName",
        "title": occu
      },
      domProps: {
        "value": occu,
        "checked": Array.isArray(_vm.member.occuPation) ? _vm._i(_vm.member.occuPation, occu) > -1 : (_vm.member.occuPation)
      },
      on: {
        "click": function($event) {
          return _vm.onClick(occu)
        },
        "change": function($event) {
          var $$a = _vm.member.occuPation,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = occu,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.member, "occuPation", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.member, "occuPation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.member, "occuPation", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(occu) + "\n              "), (occu === '기타') ? _c('span', [_vm._v("("), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.occuEtcVal),
        expression: "occuEtcVal"
      }],
      attrs: {
        "type": "text",
        "size": "12",
        "maxlength": "12",
        "id": "occuEtc",
        "title": "주된 직업군 기타 기입란"
      },
      domProps: {
        "value": (_vm.occuEtcVal)
      },
      on: {
        "keyup": _vm.checked,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.occuEtcVal = $event.target.value
        }
      }
    }), _vm._v(")")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("Email 수신")]), _vm._v(" "), _vm._l((_vm.emailCheckList), function(key, value) {
    return _c('label', {
      staticClass: "radio-inline label__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.emailCheck),
        expression: "emailCheck"
      }],
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions1",
        "title": key
      },
      domProps: {
        "value": value,
        "checked": _vm._q(_vm.emailCheck, value)
      },
      on: {
        "change": function($event) {
          _vm.emailCheck = value
        }
      }
    }), _vm._v(" " + _vm._s(key) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("SMS 수신")]), _vm._v(" "), _vm._l((_vm.smsCheckList), function(key, value) {
    return _c('label', {
      staticClass: "radio-inline label__radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.smsCheck),
        expression: "smsCheck"
      }],
      attrs: {
        "type": "radio",
        "name": "inlineRadioOptions2",
        "title": key
      },
      domProps: {
        "value": value,
        "checked": _vm._q(_vm.smsCheck, value)
      },
      on: {
        "change": function($event) {
          _vm.smsCheck = value
        }
      }
    }), _vm._v(" " + _vm._s(key) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateInfo
    }
  }, [_vm._v("다음")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('h2', {
    staticClass: "basic-form-title"
  }, [_vm._v("2. 강좌정보")]), _vm._v(" "), _c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label",
    attrs: {
      "for": "applicant-motive",
      "title": "신청하게 된 동기를 간단하게 작성해 주세요."
    }
  }, [_vm._v("위 과정을 신청하게 된 동기를 간단하게 작성해 주세요.")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.application.motive),
      expression: "application.motive",
      modifiers: {
        "trim": true
      }
    }],
    ref: "motive",
    staticClass: "input__textarea",
    attrs: {
      "rows": "4",
      "id": "applicant-motive",
      "placeholder": "최대 1000자까지 작성하실 수 있습니다.",
      "title": "최대 1000자까지 작성하실 수 있습니다."
    },
    domProps: {
      "value": (_vm.application.motive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "motive", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.forms), function(item, index) {
    return _c('div', {
      staticClass: "block-input-group clearfix"
    }, [_c('label', {
      staticClass: "block-input-label",
      attrs: {
        "title": "강좌 신청서 질문"
      }
    }, [_vm._v(_vm._s(item.question))]), _vm._v(" "), (item.type === 'SHORT') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.answers[index]),
        expression: "answers[index]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input__text",
      attrs: {
        "type": "text",
        "title": item.question
      },
      domProps: {
        "value": (_vm.answers[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers, index, $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'ESSAY') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.answers[index]),
        expression: "answers[index]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input__textarea",
      attrs: {
        "rows": "4",
        "placeholder": "최대 1000자까지 작성하실 수 있습니다.",
        "title": item.question
      },
      domProps: {
        "value": (_vm.answers[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers, index, $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'SINGLE') ? _vm._l((item.choices), function(choice) {
      return _c('label', {
        staticClass: "radio-inline label__radio",
        attrs: {
          "title": choice
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.answers[index]),
          expression: "answers[index]"
        }],
        attrs: {
          "type": "radio",
          "title": choice
        },
        domProps: {
          "value": choice,
          "checked": _vm._q(_vm.answers[index], choice)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.answers, index, choice)
          }
        }
      }), _vm._v(_vm._s(choice) + "\n            ")])
    }) : _vm._e(), _vm._v(" "), (item.type === 'MULTI') ? _vm._l((item.choices), function(choice) {
      return _c('label', {
        staticClass: "checkbox-inline label__radio",
        attrs: {
          "title": choice
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.answers[index]),
          expression: "answers[index]"
        }],
        staticClass: "input__checkbox",
        attrs: {
          "type": "checkbox",
          "title": "choice"
        },
        domProps: {
          "value": choice,
          "checked": Array.isArray(_vm.answers[index]) ? _vm._i(_vm.answers[index], choice) > -1 : (_vm.answers[index])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.answers[index],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = choice,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.answers, index, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.answers, index, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.answers, index, $$c)
            }
          }
        }
      }), _vm._v(_vm._s(choice) + "\n            ")])
    }) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn line-btn--red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToPrevious
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToStep3
    }
  }, [_vm._v("다음")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('h2', {
    staticClass: "basic-form-title"
  }, [_vm._v("3. 등록")]), _vm._v(" "), ((_vm.lecture.type === 'CHARGED' || _vm.lecture.type === 'CHARGED_CONFIRM') && _vm.lecture.lctOrgSe !== 'CAMPUS') ? _c('div', {
    staticClass: "block-input-group clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "",
      "id": "discount1",
      "title": "해당사항 없음",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "")
    },
    on: {
      "change": function($event) {
        _vm.discount = ""
      }
    }
  }), _vm._v(" 해당사항 없음\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "국가유공자",
      "id": "discount2",
      "title": "국가유공자"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "국가유공자")
    },
    on: {
      "change": function($event) {
        _vm.discount = "국가유공자"
      }
    }
  }), _vm._v("국가유공자\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "기초생활수급자",
      "id": "discount3",
      "title": "기초생활수급자"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "기초생활수급자")
    },
    on: {
      "change": function($event) {
        _vm.discount = "기초생활수급자"
      }
    }
  }), _vm._v("기초생활수급자\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "장애인복지법에 따른 장애인",
      "id": "discount4",
      "title": "장애인복지법에 따른 장애인"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "장애인복지법에 따른 장애인")
    },
    on: {
      "change": function($event) {
        _vm.discount = "장애인복지법에 따른 장애인"
      }
    }
  }), _vm._v("장애인복지법에 따른 장애인\n          ")]), _vm._v(" "), (_vm.lecture.lctOrgCd !== 'ydp') ? _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "고용보험법에 따른 실업급여수급자",
      "id": "discount5",
      "title": "고용보험법에 따른 실업급여수급자"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "고용보험법에 따른 실업급여수급자")
    },
    on: {
      "change": function($event) {
        _vm.discount = "고용보험법에 따른 실업급여수급자"
      }
    }
  }), _vm._v("고용보험법에 따른 실업급여수급자\n          ")]) : _vm._e(), _vm._v(" "), (_vm.lecture.lctOrgSe !== 'CAMPUS' && _vm.lecture.lctOrgCd !== 'sdc' && _vm.lecture.lctOrgCd !== 'ydp' && _vm.lecture.lctOrgCd !== 'sch') ? _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "북한이탈주민",
      "id": "discount6",
      "title": "북한이탈주민"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "북한이탈주민")
    },
    on: {
      "change": function($event) {
        _vm.discount = "북한이탈주민"
      }
    }
  }), _vm._v("북한이탈주민\n          ")]) : _vm._e(), _vm._v(" "), (_vm.lecture.lctOrgSe !== 'CAMPUS' && _vm.lecture.lctOrgCd !== 'sdc' && _vm.lecture.lctOrgCd !== 'ydp' && _vm.lecture.lctOrgCd !== 'sch') ? _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "discount7"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "type": "radio",
      "value": "한부모가족",
      "id": "discount7",
      "title": "한부모가족"
    },
    domProps: {
      "checked": _vm._q(_vm.discount, "한부모가족")
    },
    on: {
      "change": function($event) {
        _vm.discount = "한부모가족"
      }
    }
  }), _vm._v("한부모가족\n          ")]) : _vm._e(), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.lecture.type === 'CHARGED' || _vm.lecture.type === 'CHARGED_CONFIRM') ? _c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("환불안내")]), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline label__radio",
    attrs: {
      "for": "cofirm-agree"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }],
    staticClass: "input__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "cofirm-agree",
      "title": "cofirm-agree 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, null) > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _vm._v("\n          위 내용을 모두 확인하였으며 동의합니다.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn line-btn--red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToPrevious
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("신청하기")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-arrow-circle"
  }, [_c('img', {
    staticClass: "progress-box__img",
    attrs: {
      "src": "/images/icon-right-arrow-big.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-arrow-circle"
  }, [_c('img', {
    staticClass: "progress-box__img",
    attrs: {
      "src": "/images/icon-right-arrow-big.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "joinMotive"
    }
  }, [_vm._v("가입동기 및"), _c('br'), _vm._v(" 희망분야")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "block-input-label",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("감면/면제 신청\n            "), _c('span', {
    staticClass: "block-input-label__helper"
  }, [_vm._v("* 해당하는 경우에만 체크하세요.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box",
    attrs: {
      "tabIndex": "0"
    }
  }, [_c('h4', {
    staticClass: "text-area-box__section-title",
    staticStyle: {
      "margin-top": "0",
      "font-size": "15px"
    }
  }, [_vm._v("※ 각 기관별 더 자세한 감면/면제 안내 사항은 해당 기관의 홈페이지를 확인하여 주시기 바랍니다.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title campus",
    staticStyle: {
      "margin-top": "0",
      "color": "#C84664"
    }
  }, [_vm._v("캠퍼스 및 도심권사업팀")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부")]), _vm._v(" "), _c('li', [_vm._v("• 분기별 1개 교육과정의 수강료 면제 가능(연 4개 이하 교육과정 수강료 면제 가능)")]), _vm._v(" "), _c('li', [_vm._v("   ※ 외부기관 협력(연계 유료 교육과정 포함)")]), _vm._v(" "), _c('li', [_vm._v("• 강좌 종료 후 수료한 분들에 한하여, 상담센터에서 증빙서류를 확인 후 환불처리 진행")]), _vm._v(" "), _c('li', [_vm._v("• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(주민등록상 서울시 거주자에 한함)")]), _vm._v(" "), _c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(모든 서류는 3개월 이내 발급된 것이어야 함)")]), _vm._v(" "), _c('li', [_vm._v("•(공통) 학습비 면제신청서 1부, 주민등록등본(주소지 확인용)")]), _vm._v(" "), _c('li', [_vm._v("•국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("•국가 유공자(유족) 확인서(신청인에 신청자 본인 명기 必), 국가유공자증, 국가유공자 유족증(택1)")]), _vm._v(" "), _c('li', [_vm._v("•장애인 증명서(등록증), 복지카드 사본(택1)")]), _vm._v(" "), _c('li', [_vm._v("•고용보험수급자격증(실업자 수급 수첩) 사본")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("동작50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("홈페이지 프로그램 신청 후, 수강료 선 납부 /")]), _vm._v(" "), _c('li', [_vm._v("결제 완료 후 증빙서류 지참, 센터 방문시 담당자에 제출 / 환급처리")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자 본인 (100% 환급)과  그 직계가족 (50% 환급)")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1. (공통) 신분증 사본 1부")]), _vm._v(" "), _c('li', [_vm._v("2. (해당자) 수급자 확인서, 유공자 확인서, 복지카드 사본1부")]), _vm._v(" "), _c('li', [_vm._v("3. (해당자) 가족관계증명서 1부")]), _vm._v(" "), _c('li', [_vm._v("4. (해당자) 환불계좌 통장사본 1부 (무통장입금자)")]), _vm._v(" "), _c('li', [_vm._v("5. 카드결제자는 카드 취소")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("노원50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 노원구 장년층 인생이모작 지원에 관한 조례(2017.3.16.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강료 면제 대상자는 강좌 신청 후 반드시 수강료 전액을 납부")]), _vm._v(" "), _c('li', [_vm._v("• 면제 횟수는 연간 1인 2회까지(교육시작일 기준) ")]), _vm._v(" "), _c('li', [_vm._v("• 강좌를 수료한 면제대상자는 종강일 기준 7일전~종강일까지 증빙서류 제출(2층사무실)")]), _vm._v(" "), _c('li', [_vm._v("   (수료생기준:70%이상 출석자)")]), _vm._v(" "), _c('li', [_vm._v("• 감면 대상 서류 제출일 기준 2주이내 환불처리")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• (공통) 신분증 사본 1부, 환불계좌 통장사본 1부")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) ")]), _vm._v(" "), _c('li', [_vm._v("   - 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("   - 국가유공자 확인서(국가유공자 가족 : 가족관계증명서) 또는 국가유공자증, 국가유공자유족증")]), _vm._v(" "), _c('li', [_vm._v("   - 장애인증명서(등록증) 또는 복지카드 사본")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("서대문50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 서대문구 장년층 인생이모작 지원에 관한 조례」 (2019.7.10.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("수강료 면제 기준에 해당되어도 먼저 수강료를 납부해야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("수업을 이수한 뒤, 면제 신청서를 작성하시면 2주 내에 환급 처리됩니다.")]), _vm._v(" "), _c('li', [_vm._v("*이수증은 70%이상 출석 시 발급됩니다.")]), _vm._v(" "), _c('li', [_vm._v("*수강료 면제는 연 1회만 가능합니다.")]), _vm._v(" "), _c('li', [_vm._v("* 수강료 결제방법에 따라 카드결제 취소 혹은 결제(지정)계좌로 환불 진행됩니다.")]), _vm._v(" "), _c('li', [_vm._v("※ 유의사항 : 수강료는 면제이나 ‘재료비 및 교재비’는 면제 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」에 따른 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인복지법」에 따라 장애인으로 등록된 자")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1. (공통) 수강료 면제 신청서 1부")]), _vm._v(" "), _c('li', [_vm._v("2. (공통) 신분증 사본 및 통장사본 1부")]), _vm._v(" "), _c('li', [_vm._v("3. (해당자) 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("4. (해당자) 국가 유공자(유족) 확인서")]), _vm._v(" "), _c('li', [_vm._v("5. (해당자) 장애인 증명서(등록증) 또는 복지카드 사본")]), _vm._v(" "), _c('li', [_vm._v("6. (해당자) 고용보험수급자격증(실업자 수급 수첩) 사본")]), _vm._v(" "), _c('li', [_vm._v("※모든 서류는 3개월이내 발급된 것이어야 함")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("성북50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 본인이 센터에 방문하여 접수, 신청서 및 '구비서류' 제출 필수 (홈페이지 접수 및 전화접수 불가능)")]), _vm._v(" "), _c('li', [_vm._v("• 면제대상자 1인에 연간 2회까지 면제")]), _vm._v(" "), _c('li', [_vm._v("• 면제대상자도 유료강좌 수강신청 후 반드시 수강료 결제 진행해야 하며, '수료자에 한해서만' 환급")]), _vm._v(" "), _c('li', [_vm._v("• 환급시기: 강좌 종료 후 1주 이내")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활 보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우 및 지원에 관한 법률」에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인복지법」에 따라 장애인으로 등록된 자")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")]), _vm._v(" "), _c('li', [_vm._v("   ※ 유의사항: 수강료는 면제이나 '재료비 및 교재비는 별도' 부담")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• (공통) 수강료 면제 신청서 - 센터 방문하여 작성")]), _vm._v(" "), _c('li', [_vm._v("• (공통) 신분증 사본")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국가유공자/유족 확인서 - 신청인에 신청자 본인 명기 필수")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 장애인 증명서 또는 복지카드 사본")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본")]), _vm._v(" "), _c('li', [_vm._v("   ※ 유의사항: 모든 서류는 3개월 이내 발급된 것이어야 함.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("금천50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 장년층 인생이모작지원에 관한 조례 제6조의4(사용료의 감면 등)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 방문접수를 필수로 하며 온라인 및 전화접수는 불가능 하다.")]), _vm._v(" "), _c('li', [_vm._v("• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부")]), _vm._v(" "), _c('li', [_vm._v("• 연간 2개 교육과정의 수강료 면제가 가능, 면제 대상자는 강좌별 정원의 20%룰 초과할 수 없음")]), _vm._v(" "), _c('li', [_vm._v("• 강좌 종료 후 수료한 분들에 한하여, 금천50플러스센터에서 증빙서류를 확인 후 환불처리 진행")]), _vm._v(" "), _c('li', [_vm._v("• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("•「국가유공자 등 예우에 관한 법률」에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("•「장애인 복지법」에 따라 장애인으로 등록된 자")]), _vm._v(" "), _c('li', [_vm._v("•「고용보험법」에 따른 실업급여 수급자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(공통) 수강료 면제 신청서")]), _vm._v(" "), _c('li', [_vm._v("• 국민기초생활수급자증명서")]), _vm._v(" "), _c('li', [_vm._v("• 국가유공자(유족)확인서(신청인에 신청자 본인 명기 必)")]), _vm._v(" "), _c('li', [_vm._v("• 가족관계증명서(해당자)")]), _vm._v(" "), _c('li', [_vm._v("• 장애인등록증(복지카드 사본)")]), _vm._v(" "), _c('li', [_vm._v("• 고용보험수급자격카드(실업자 수급 수첩)")]), _vm._v(" "), _c('li', [_vm._v("※ 모든 서류는 신청일 기준 3개월 이내 발급된 것이어야 함.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강서50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 강서구 중·장년층 인생이모작 지원에 관한 조례 시행규칙(2021.6.16.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 아래 '면제 신청방법 구비서류' 를 가지고 본인이 센터에 방문하여 접수.")]), _vm._v(" "), _c('li', [_vm._v("• 면제대상자(본인) 연간 2회까지 면제 ")]), _vm._v(" "), _c('li', [_vm._v("• 면제대상자도 유료강좌 수강신청 후 반드시 수강료 결제 진행해야 하며, '이수자에 한해서만' 환급")]), _vm._v(" "), _c('li', [_vm._v("   ※ 이수자(수료자) : 신청한 강좌의 70%이상 출석 시 인정.")]), _vm._v(" "), _c('li', [_vm._v("• 환불시기 : 강좌 종료 후 2주 이내.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활 보장법」에 의한 수급자 ")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우 및 지원에 관한 법률」에 의한 국가유공자와 그 직계가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인복지법」에 따라 장애인으로 등록된 자")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")]), _vm._v(" "), _c('li', [_vm._v("   ※ 교육 개강일 기준 면제대상 시 적용.")]), _vm._v(" "), _c('li', [_vm._v(" ※ 재료비 및 교재비는 면제대상에 해당되지 않음.(본인 별도부담)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• (공통) 수강료 면제(감면) 신청서")]), _vm._v(" "), _c('li', [_vm._v("• (공통) 신분증 사본 1부 ")]), _vm._v(" "), _c('li', [_vm._v("• (공통) 본인 명의의 환불계좌 통장 사본 1부")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국가유공자/유족 확인서")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 장애인 증명서 또는 복지카드 사본")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본")]), _vm._v(" "), _c('li', [_vm._v(" ※ 모든 서류는 3개월 이내 발급된 것이어야 함.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("서초50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 서초구 장년층 인생이모작 지원에 관한 조례[시행2020.2.6.]")]), _vm._v(" "), _c('li', [_vm._v("제 8조(사용료의 감면)에 의한 규정 사안」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부")]), _vm._v(" "), _c('li', [_vm._v("• 수강신청시 면제 대상자 해당 체크란에 사전 체크한 분들에 한하여 면제 가능 ")]), _vm._v(" "), _c('li', [_vm._v("• 연 2회 교육과정의 수강료 면제가 가능")]), _vm._v(" "), _c('li', [_vm._v("• 강좌 종료 후 수료한 분들에 한하여, 증빙서류를 확인 후 환불처리 진행")]), _vm._v(" "), _c('li', [_vm._v("• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 80%이상 출석)")]), _vm._v(" "), _c('li', [_vm._v("• 증빙서류 제출 시 방문접수 필수")]), _vm._v(" "), _c('li', [_vm._v("• 수강료 면제시 교재비, 재료비는 면제되지 않음")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(공통) 수강료 면제신청서 1부, 신분증 사본 또는 주민등록등본(주소지 확인용),")]), _vm._v(" "), _c('li', [_vm._v("   환불계좌 통장사본 1부, 해당 강좌 이수증 1부.")]), _vm._v(" "), _c('li', [_vm._v("(해당자) 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("   국가 유공자(유족) 확인서(신청인에 신청자 본인 명기 必),")]), _vm._v(" "), _c('li', [_vm._v("   국가유공자증, 국가유공자 유족증(택1)")]), _c('li', [_vm._v("   장애인 증명서(등록증), 복지카드 사본(택1)")]), _vm._v(" "), _c('li', [_vm._v("   고용보험수급자격증(실업자 수급 수첩) 사본")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강동50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 장년층 인생이모작지원에 관한 조례(2021.5.26.) 제9조(사용료 등)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강료 면제 대상자는 최종 승인완료 문자를 받은 후, 결제기일 내에 증빙 서류를 제출하면")]), _vm._v(" "), _c('li', [_vm._v("   수강료 면제(전액 납부 후 환불 처리 지양)")]), _vm._v(" "), _c('li', [_vm._v("• 수강료 감면 대상자(한부모가족)는 서류 접수 후 50%범위 이내 환불 처리")]), _vm._v(" "), _c('li', [_vm._v("• 최대 연 2회 면제/감면이 가능하여 강좌별 승인 문자를 받은 후, ")]), _vm._v(" "), _c('li', [_vm._v("   감면/전액 결제하는 방법 중 수강 대상자가 선택")]), _vm._v(" "), _c('li', [_vm._v("• 교재비와 재료비는 개강 후 강사에게 별도 납부하며, 감면/면제 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("수강료 면제·감면기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대상")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("증빙서류")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v("면제")]), _vm._v(" "), _c('td', [_vm._v("국가유공자와 그 유족 또는 가족")]), _vm._v(" "), _c('td', [_vm._v("국가유공자 확인서, 국가 유공자증."), _c('br'), _vm._v("국가유공자 유족증(택1)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("국민기초생활 수급자")]), _vm._v(" "), _c('td', [_vm._v("국민기초생활 수급자 증명서")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("등록장애인")]), _vm._v(" "), _c('td', [_vm._v("장애인 증명서(등록증),"), _c('br'), _vm._v("복지카드사본(택1)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("고용보험 수급자격 인정자")]), _vm._v(" "), _c('td', [_vm._v("고용보험 수급자격증"), _c('br'), _vm._v("(실업자 수급급여 수첩) 사본")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("북한이탈주민 보호대상자")]), _vm._v(" "), _c('td', [_vm._v("북한이탈주민 등록확인서")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("그 밖에 사용료 감면이 필요하다고"), _c('br'), _vm._v("구청장이 인정하는 사람")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("50% 범위"), _c('br'), _vm._v("이내 감면")]), _vm._v(" "), _c('td', [_vm._v("한부모가족")]), _vm._v(" "), _c('td', [_vm._v("한부모가족증명서")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 아래 2가지 서류를 온라인으로 제출(수신 이메일: gdc@50center.or.kr)")]), _vm._v(" "), _c('li', [_vm._v("  1) 수강료 면제 신청서 1부")]), _vm._v(" "), _c('li', [_vm._v("  2) 증빙서류(해당하는 감면 사유에 맞는 증빙 서류, 위의 표 참고)")]), _vm._v(" "), _c('li', [_vm._v("  ※ 모든 서류는 신청일 기준 3개월 이내 발급된 것이어야 함")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("양천50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 장년층 인생이모작지원에 관한 조례(2017.1.5.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강료 면제 대상자(세부 기준은 하단 참조)는 강좌 신청 후 반드시 수강료 전액을 납부")]), _vm._v(" "), _c('li', [_vm._v("• 반기별 1개 교육과정의 수강료 면제가 가능(연 2개 이하 교육과정 수강료 면제 가능)")]), _vm._v(" "), _c('li', [_vm._v("  ※ 면제는 교육정원의 10%로 제한(신청자가 다수일 경우, 선착순 결제완료자 우선 선정)")]), _vm._v(" "), _c('li', [_vm._v("• 강좌 종료 후 수료한 분들에 한하여, 상담센터에서 증빙서류를 확인 후 환불처리 진행")]), _vm._v(" "), _c('li', [_vm._v("• 유료강좌를 수료한 면제 대상자는 종강 후, 1주일 이내에 증빙서류를 제출 (※ 수료기준: 70%이상 출석)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자 본인")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자(수급자격인정일자가 교육시작일 이전)")]), _vm._v(" "), _c('li', [_vm._v("• 「북한이탈주민의 보호 및 정착지원에 관한 법률」에 따른 보호대상자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("(공통) 학습비 면제신청서 1부, 주민등록등본(주소지 확인용)")]), _vm._v(" "), _c('li', [_vm._v("   국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("   국가 유공자 확인서(신청인에 신청자 본인 명기 必), 국가유공자증(확인서)")]), _vm._v(" "), _c('li', [_vm._v("   장애인 증명서(등록증), 복지카드 사본(택1)")]), _vm._v(" "), _c('li', [_vm._v("   고용보험수급자격증(실업자 수급 수첩) 사본")]), _vm._v(" "), _c('li', [_vm._v("   북한이탈주민 등록확인서")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("성동50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 성동구 장년층 인생이모작 지원에 관한 조례(시행 2021.3.15.)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• ‘면제 신청 강좌 개강일’ 기준 면제 자격 유지 대상자 중 해당 강좌 이수자(이수기준 : 70%이상 출석)")]), _vm._v(" "), _c('li', [_vm._v("• 연 2회까지 가능")]), _vm._v(" "), _c('li', [_vm._v("• ‘면제 신청 구비서류’ 지참하여 운영지원팀 사무실 내방, 신청서 작성 후 접수")]), _vm._v(" "), _c('li', [_vm._v("• 면제 신청강좌 종강일까지 개별 접수 진행")]), _vm._v(" "), _c('li', [_vm._v("• 강좌 종강 이후 2주 이내 처리")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 국민기초생활보장법」에 의한 수급자")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• (공통)신분증 사본 1부 ")]), _vm._v(" "), _c('li', [_vm._v("• (공통)본인 명의의 환불계좌 통장 사본 1부(계좌이체로 입금한 경우)")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국민기초생활수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 국가유공자/유족 확인서")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 장애인 증명서 또는 복지카드 사본")]), _vm._v(" "), _c('li', [_vm._v("• (해당자) 고용보험수급자격증 카드/실업자 수급수첩 사본")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강북50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- 수강신청 → 결제 → 강좌 수강 및 이수 → 면제신청")]), _vm._v(" "), _c('li', [_vm._v("  ※ 면제 대상자 체크  ※ 출석율 70% 이상 ※ 면제신청서 작성 및 구비서류 준비 후 신청")]), _vm._v(" "), _c('li', [_vm._v("- 수강신청 시 반드시 ‘면제 대상자’를 체크하셔야 수강료 면제 대상자가 됩니다.")]), _vm._v(" "), _c('li', [_vm._v("  ※ 수급자격 인정일자가 교육시작일 이전이어야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("예) 면제대상 O : 교육시작(2/1~), 수급자격 인정(1/31~)")]), _vm._v(" "), _c('li', [_vm._v("   면제대상 X : 교육시작(2/1~), 수급자격 인정(2/2~)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 「국민기초생활보장법」에 의한 수급자 : 국민기초 생활 수급자 증명서")]), _vm._v(" "), _c('li', [_vm._v("• 「국가유공자 등 예우에 관한 법률」 제 4조에 의한 국가유공자와 그 가족: 국가 유공자 확인서")]), _vm._v(" "), _c('li', [_vm._v("• 「장애인 복지법」에 따른 등록 장애인: 장애인 증명서 또는 복지카드")]), _vm._v(" "), _c('li', [_vm._v("• 「고용보험법」에 따른 실업급여 수급자: 고용보험수급자격증(실업자 수급 수첩) 사본")]), _vm._v(" "), _c('li', [_vm._v("• 「북한이탈주민의 보호 및 정착지원」에 따른 보호대상자: 북한이탈주민 등록확인서")]), _vm._v(" "), _c('li', [_vm._v("- 그 밖에 수강료 감면이 필요하다고 구청장이 인정하는 사람")]), _vm._v(" "), _c('li', [_vm._v("- 모든 서류는 3개월 이내 발급된 것이어야 함")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- 개인당 연2회 수강료 면제 가능(상반기, 하반기 각 1회)")]), _vm._v(" "), _c('li', [_vm._v("- 강좌당 정원의 30%로 제한(다수의 신청자가 있을 경우 선착순 결제 완료자를 원칙 선정함)")]), _vm._v(" "), _c('li', [_vm._v("- 종강 후 2주 이내 면제 신청서 제출(2주 이내 수강료 환불 예정)")]), _vm._v(" "), _c('li', [_vm._v("- 면제 대상자도 수강료 선결제 이후 강좌를 이수한자에 한해 수강료 면제")]), _vm._v(" "), _c('li', [_vm._v("- 이수 확인 후, 구비서류(면제신청서, 이수증, 구비서류, 신분증, 통장사본 등) 방문")]), _vm._v(" "), _c('li', [_vm._v("  또는 이메일(gb50plus@naver.com) 제출")]), _vm._v(" "), _c('li', [_vm._v("- 재료비 및 교재비는 면제 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("수강료 면제 제출 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("-(공통) 면제 신청서, 강좌이수증, 신분증, 통장사본 각 2부.")]), _vm._v(" "), _c('li', [_vm._v("-(해당자) 수강료 면제대상자를 확인할 수 있는 증빙서류(3개월 이내 발급)")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("용산50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 중장년층 인생이모작지원에 관한 조례(2021.5.26.) 제9조(사용료 등)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 안내 및 절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("수강료 감면/면제 대상자는 전액 납부 이후 출석률 70% 수료 시 수강료 반환을 받을 수 있음.(서울시50플러스센터 교육 운영 기준)")]), _vm._v(" "), _c('li', [_vm._v("  단, 신청 시 반드시 감면 대상 체크박스에 체크하여야 함")]), _vm._v(" "), _c('li', [_vm._v("수강료 감면 대상자(한부모가족)는 서류 접수 후 50% 범위 이내 환불 처리")]), _vm._v(" "), _c('li', [_vm._v("최대 연 2회 면제/감면이 가능하여 강좌별 승인 문자를 받은 후, 감면/전액 결제하는 방법 중 수강 대상자가 선택")]), _vm._v(" "), _c('li', [_vm._v("교재비 및 재료비는 개강 후 강사에게 별도 납부, 감면/면제 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("면제 대상")]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("수강료 면제·감면기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대상")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("증빙서류")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("「국가유공자 등 예우 및 지원에 관한 법률」에 따른 국가유공자와 그 가족")]), _vm._v(" "), _c('td', [_vm._v("국가유공자(유족) 확인서(신청인에 신청자 본인 명기 必) 또는 국가 유공자증(유족증)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("「국민기초생활 보장법」에 따른 수급자")]), _vm._v(" "), _c('td', [_vm._v("국민기초생활수급자 증명서")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("「장애인복지법」에 따라 등록된 장애인으로 등록된 사람")]), _vm._v(" "), _c('td', [_vm._v("장애인 증명서(등록증) 또는 복지카드 사본")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("「고용보험법 시행령」 제62조에 따른 수급자격 인정자")]), _vm._v(" "), _c('td', [_vm._v("고용보험 수급자격증 또는 실업자 수급 수첩 사본")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("「북한이탈주민의 보호 및 정착지원에 관한 법률」 제 2조에 따른 보호대상자")]), _vm._v(" "), _c('td', [_vm._v("북한이탈주민 등록확인서")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("한부모가족 (50% 범위 이내 감면)")]), _vm._v(" "), _c('td', [_vm._v("한부모 가족증명서")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("그 밖에 사용료 감면이 필요하다고 구청장이 인정하는 사람")]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("구비 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- (공통) 면제신청서, 강좌이수증(출석률 70% 수료 시 발급) 각 1부")]), _vm._v(" "), _c('li', [_vm._v("- (해당자) 수강료 면제 대상자를 확인 할 수 있는 증빙서류(3개월 이내 발급된 것이어야 함)")]), _vm._v(" "), _c('li', [_vm._v("- 제출방법: 용산50플러스센터 이메일 ysc@50center.or.kr 또는 방문 제출")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("수강료 면제 제출 서류")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("-(공통) 면제 신청서, 강좌이수증, 신분증, 통장사본 각 2부.")]), _vm._v(" "), _c('li', [_vm._v("-(해당자) 수강료 면제대상자를 확인할 수 있는 증빙서류(3개월 이내 발급)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box",
    attrs: {
      "tabIndex": "0"
    }
  }, [_c('h4', {
    staticClass: "text-area-box__section-title",
    staticStyle: {
      "margin-top": "0",
      "font-size": "15px"
    }
  }, [_vm._v("※ 각 기관별 더 자세한 환불 안내 사항은 해당 기관의 홈페이지를 확인하여 주시기 바랍니다.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title campus",
    staticStyle: {
      "margin-top": "0",
      "color": "#C84664"
    }
  }, [_vm._v("캠퍼스 및 도심권사업팀")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월 이내인 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 후")]), _vm._v(" "), _c('td', [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월을 초과하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업시작 후")]), _vm._v(" "), _c('td', [_vm._v("환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1일 특강 및 단기 특강")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("개강일 이전까지만 전액 환불 가능")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("비고")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.\n"), _c('br'), _c('br'), _vm._v("※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용\n2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.\n"), _c('br'), _vm._v("※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로, 학습 포기 의사를 \n"), _c('br'), _vm._v(" 밝힌 날의 다음날부터 계산하여 반환함\n"), _c('br'), _vm._v("※ 환불시 10원 미만은 절사함")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강 후 재료비는 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨")]), _vm._v(" "), _c('li', [_vm._v("•신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불")]), _vm._v(" "), _c('li', [_vm._v("- 개강 전 취소는 100% 환불(카드 취소)")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("동작50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강 1일전 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("비고")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("강좌 개강 1일전")]), _vm._v(" "), _c('td', [_vm._v("전액 활불")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("수강 취소일 기준"), _c('br'), _vm._v("개강 후 재료비는 환불 불가")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("당일, 개강후 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("수강료의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("개강 후 1/2 경과 전")]), _vm._v(" "), _c('td', [_vm._v("수강료의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("개강 후 1/2 경과 ")]), _vm._v(" "), _c('td', [_vm._v("환불 불가")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불")]), _vm._v(" "), _c('li', [_vm._v("- 개강 전 취소는 100% 환불(카드 취소)")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 부분 환불은 환불 신청자 명의 계좌로 무통장 입금")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("노원50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 환불기준 : 수강료 환불신청일 기준(수강여부와 무관)")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환 사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("환불 금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("센터 사정, 천재지변")]), _vm._v(" "), _c('td', [_vm._v("수강료 전액 환불")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업시작 1일전까지")]), _vm._v(" "), _c('td', [_vm._v("수강료 전액 환불")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업당일 ~ 총 수업기간의 1/3경과 전 (회차기준)")]), _vm._v(" "), _c('td', [_vm._v("수강료의 2/3 해당금액 환불")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업기간의 1/2경과 전 (회차기준)")]), _vm._v(" "), _c('td', [_vm._v("수강료의 1/2 해당금액 환불")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업기간의 1/2 경과 (회차기준)")]), _vm._v(" "), _c('td', [_vm._v("환불 불가능")])])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 무통장입금, 카드결제 모두 반드시 본인명의 계좌번호 입력(필수)")]), _vm._v(" "), _c('li', [_vm._v("• 본인명의 계좌번호 아니거나 계좌번호 작성오류 시 지급가능한 본인명의 통장사본 제출")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강 후(개강당일포함) 재료비 및 교재비는 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("• 개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨")]), _vm._v(" "), _c('li', [_vm._v("• 신용카드 결제 신청자의 개강 후 환불은 무통장 입금(계좌이체)으로 환불")]), _vm._v(" "), _c('li', [_vm._v("- 개강 전 취소는 100% 환불(카드 취소)")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금")]), _vm._v(" "), _c('li', [_vm._v("• 환불금액 10원 미만 금액은 절사")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("서대문50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 수강료를 결제한 방법으로 환불)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강일 이전(전일 23:59까지)은 전액 환불되며, 개강일 이후는 남은 회차를 산정하여 수강료 환불")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col",
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("내용")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("회차 단위 구성")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수업이 주1회·주3회 등으로 구성되거나, ‘10회차’ 과정 등으로 구성되어, 총 수업회차를 기준으로 학습비를 납부하게 되는 경우"), _c('br'), _vm._v("  ※ 공휴일 등으로 인해 휴강하는 경우는 총 수업회차에서 해당 회차만큼 제외, 보강이 이루어지는 경우는 총 수업회차에 해당 회차 포함")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("학습지 징수기간")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("① 학습비 징수기간: 학습비를 일괄 징수하는 수업기간\n                  "), _c('br'), _vm._v("  - 1개월 이내: 1개월 이내의 수업기간 단위로 학습비를 징수하는 경우\n                  "), _c('br'), _vm._v("  - 1개월 초과: 1개월을 초과하는 수업기간 단위로 학습비를 징수하는 경우\n\t\t\t\t  "), _c('br'), _vm._v("② 1개월 산정 기준\n\t\t\t\t  "), _c('br'), _vm._v("  - 민법 제160조(역에 의한 계산)를 적용\n\t\t\t\t  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("학습비 반환 기준")]), _vm._v(" "), _c('td', [_vm._v("수업기간이 1개월 이내인 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("- 수업시작 전 : 이미 낸 학습비 전액\n\t\t\t\t  "), _c('br'), _vm._v("- 잔여회차가 총 수업회차의 2/3이상인 경우 : 이미 낸 학습비의 2/3 해당액\n\t\t\t\t  "), _c('br'), _vm._v("- 잔여회차가 총 수업회차의 1/2이상, 2/3미만인 경우 : 이미 낸 학습비의 1/2 해당액\n\t\t\t\t  "), _c('br'), _vm._v("- 잔여회차가 총 수업회차의 1/2미만인 경우 : 반환하지 아니함\n\t\t\t\t  ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업기간이 1개월 초과인 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("- 수업시작 전 : 이미 낸 학습비 전액\n  \t\t\t\t  "), _c('br'), _vm._v("- 수업시작 후 : 반환사유가 발생한 ‘달’의 반환대상 학습비+나머지 달의 학습비 전액*\n\t\t\t\t  "), _c('br'), _vm._v("  * 나머지 달의 학습비 전액 : (나머지 달의 회차/총 수업회차) x 총학습비")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("기타사항")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("- 학습 포기 의사를 밝힌 시점(수업일 전날 23:59) 기준 잔여 회차에 대해 계산하여 반환함\n\t\t\t\t  "), _c('br'), _vm._v("  * 일일특강(원데이 클래스)은 개강 전날(23:59)까지 취소하였을 경우 전액환불함.\n\t\t\t\t  "), _c('br'), _vm._v("- 10원 미만은 절사함\n\t\t\t\t  "), _c('br'), _vm._v("- 자세한 내용은 평생교육법 시행령 제23조 관련 [별표3] 개정 내용 참조")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강 후 재료비는 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("• 개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨")]), _vm._v(" "), _c('li', [_vm._v("• 신용카드 결제 신청자의 환불은 결제(부분)취소로 환불")]), _vm._v(" "), _c('li', [_vm._v("• 무통장입금(가상계좌) 신청자의 환불은 신청자 명의 결제계좌로 환불")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("성북50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 로그인 → 마이페이지 → 내강좌 → 수강확인 및 취소")]), _vm._v(" "), _c('li', [_vm._v("• 수강생 명과 동일한 예금주의 계좌번호/은행 입력 (※ 카드결제의 경우도 계좌번호 작성해야 함)")]), _vm._v(" "), _c('li', [_vm._v("• 개강 전 취소: 개강일 이후 1주 이내")]), _vm._v(" "), _c('li', [_vm._v("• 개강 이후 취소: 환불신청일로부터 2주 이내")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 1일 특강은 '개강일 이전' 까지만 전액환불 가능")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/3 경과 전: 납부한 수강료의 2/3 해당액")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/2 경과 전: 납부한 수강료의 1/2 해당액")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/2 경과 후: 납부한 수강료 전액 반환하지 않음.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강 후 재료비 및 교재비 등은 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("• 개강 후 '중간신청자'의 경우도 동일하게 '강좌개강일'을 기점으로 동일한 환불 기준 적용")]), _vm._v(" "), _c('li', [_vm._v("• 실제 수강여부와 무관하게 '마이페이지-내강좌' 메뉴에서 수강취소를 진행한 '수강취소일'을 기준으로 환불금액 산정")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("금천50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 로그인 ⇒ 마이페이지 내 수강확인 및 취소 ⇒ 은행·계좌번호 작성 ⇒ 수강생명 및 예금주 동일 여부를 확인 ")]), _vm._v(" "), _c('li', [_vm._v("    ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 내 온라인 접수를 통해서만 환불 가능하며, 방문 및 유선으로는 불가능하다.")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("모집정원 미달로 폐강 시, 1일 특강 및 강좌 개강일 전")]), _vm._v(" "), _c('td', [_vm._v("전액 환불")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수강취소일 기준 총 수강 횟수의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("납부 수강료의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수강취소일 기준 총 수강 횟수의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("납부 수강료의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수강취소일 기준 총 수강 횟수의 1/2 경과 후")]), _vm._v(" "), _c('td', [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("센터의 사정으로 교육프로그램이 취소 또는 정지되거나 천재지변·재해, 전염성 질병 또는 이에 준하는 사유로 교육프로그램의 진행이 불가능한 경우 수강횟수를 제외한 잔여 횟수에 해당하는 금액을 계산하여 반환")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("•수강생의 수강취소 및 모집정원 미달로 인한 폐강, 센터의 사정으로 교육프로그램이 취소 또는 정지되거나\n천재지변·재해, 전염성 질병 또는 이에 준하는 사유 등으로 환불이 발생할 경우 환불 기준에 따라 수강료    전액 또는 일부를 환불사유 발생일로부터 운영일 기준 7일 이내 지급한다.\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("•센터 지정 은행 외 타 은행 계좌 환불 요청 시 수수료 발생분은 수강생이 부담하며, 개강 후 재료, 교재비환불이 불가능하다.\n"), _c('br'), _vm._v("※ 수수료 발생 부분 : 타 은행 계좌 이체 시 수수료, 카드취소 시 발생되는 사업자 수수료 등\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("• 개강 후 수강 취소 시 프로그램별 교재비와 재료비 등 강의 과정에 수반되는 비용은 환불이 불가하다. 다만, 자격증 발급비용 등 강의 진행 과정과 별도로 산정된 비용은 협의를 통해 환불을 진행할 수 있다.\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("• 환불 금액은 원 단위 절상하여 지급한다.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨")]), _vm._v(" "), _c('li', [_vm._v("• 결제 방법에 따라 카드결제 건은 카드취소로, 무통장 입금 건은 계좌이체로 환불 진행.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강서50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 강서구 중·장년층 인생이모작 지원에 관한 조례 시행규칙(제4조 사용료 등의 반환)」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 로그인 → 마이페이지 → 내강좌 → 수강확인 및 취소")]), _vm._v(" "), _c('li', [_vm._v("• 수강생 명과 예금주의 계좌번호/은행 입력 (※카드결제의 경우 계좌번호 작성해야 함)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 개강 1일 전까지는 납부한 수강료 전액 환불")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/3 경과 전 : 납부한 수강료의 2/3 해당액")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/2 경과 전 : 납부한 수강료의 1/2 해당액")]), _vm._v(" "), _c('li', [_vm._v("• (수강취소일 기준) 총 수강횟수의 1/2 경과 후 : 환불 불가.")]), _vm._v(" "), _c('li', [_vm._v("※ 기관 사정과 모집정원 미달에 의한 폐강 시 폐강 공고 후 전액 환불.")]), _vm._v(" "), _c('li', [_vm._v("※ 환불시 10원 미만은 올림함.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" • 환불처리는 환불 신청일로부터 2주 이내.")]), _vm._v(" "), _c('li', [_vm._v("※ 연간 2회이상 환불자는 이후 교육신청 시 후순위(대기자)로 선정될 수 있음.")]), _vm._v(" "), _c('li', [_vm._v("※ 개강일 이후 재료비 및 교재비 등은 환불 불가.")]), _vm._v(" "), _c('li', [_vm._v("※ 유료강좌의 경우 환불신청 계좌번호 입력.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("서초50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("개강일 전")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("개강일 이후"), _c('br'), _vm._v("(개강 당일 포함)")]), _vm._v(" "), _c('td', [_vm._v("총 수업시간의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 후")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1회기 강의")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("비고")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("※ 개강 후 교재비, 재료비는 환불 불가"), _c('br'), _vm._v("※ 환불시 원단위 절사함")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강 후 재료비는 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("•신용카드 결제 신청자의 개강 후 환불은 카드 부분취소로 환불")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강동50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 강동구 장년층 인생이모작 지원조례」제9조 (사용료 등) ")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 카드결제인 경우 카드 (부분)취소 처리/무통장입금의 경우 본인 명의 계좌로 환급됨)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "60%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("내용")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("환불 기준")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("모집정원 미달로 폐강하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수강료 전액 반환")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1일특강 및 강좌 개강일 전일까지 취소하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수강료 전액 반환")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("개강일부터 총 수강횟수의 3분의 1이 경과하기 전까지 취소하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수강료 3분의 2 반환")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수강횟수의 3분의 1 경과 이후부터 2분의 1이 경과하기 전까지 취소하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수강료 2분의 1 반환")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수강횟수 2분의 1 경과 이후 취소")]), _vm._v(" "), _c('td', [_vm._v("수강료 미반환")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("인생이모작 지원시설의 사정으로 프로그램이 취소 또는 정지되거나 천재지변·재해 또는 이에 준하는 사유로 프로그램 진행이 불가능한 경우")]), _vm._v(" "), _c('td', [_vm._v("수강횟수를 제외한 잔여 횟수에 해당되는 금액을 계산하여 반납")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•환불액 산정은 반환사유가 발생한 날까지를 경과된 수업시간으로 책정함.")]), _vm._v(" "), _c('li', [_vm._v(" 즉, 학습포기 의사를 밝힌 날의 다음 날부터 계산하여 반환함")]), _vm._v(" "), _c('li', [_vm._v(" (단, 학습포기의사를 밝힌 날은 실제 수강여부와 상관없이 홈페이지에서 수강취소를 진행한 해당일로 봄)")]), _vm._v(" "), _c('li', [_vm._v("•환불시 10원 미만은 절사함")]), _vm._v(" "), _c('li', [_vm._v("•센터의 지정 은행 외 타 은행 계좌환불 요청시 수수료는 수강생이 직접 부담하며 개강 후 재료비 및 교재비는 환불 불가능 합니다.")]), _vm._v(" "), _c('li', [_vm._v(" -수수료 발생 부분: 타 은행 계좌이체시 수수료, 카드 취소시 발생된는 사업자 수수료")]), _vm._v(" "), _c('li', [_vm._v("•개강 후 중간에 신청한 경우에도 강좌 개강일 시점으로 동일한 환불 기준을 적용합니다.")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("양천50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•홈페이지 로그인 ⇒ 마이페이지 內 수강확인 및 취소 ⇒ 환불 처리(신청일로부터 2주 이내, 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월 이내인 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 후")]), _vm._v(" "), _c('td', [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월을 초과하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업시작 후")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나머지 잔여달(잔여회차)의 학습비 전액을 합산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1일 특강 및 단기 특강")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("개강일 이전까지만 전액 환불 가능")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("비고")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1. ‘학습비 징수기간’이란 징수된 총학습비에 따른 총 수업일을 말한다.\n"), _c('br'), _vm._v(" ※ 징수기간에서 1개월이란 「평생교육시설 관련 학습비 반환기준 해석지침」에 의거 강의 시작일로부터 적용\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("2. ‘총 수업시간’이란 학습비 징수기간 중의 총 수업시간(회차)을 말한다.\n"), _c('br'), _vm._v(" ※ 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간(회차)을 기준으로, 학습 포기 의사를 밝힌 날의 다음날부터 계산하여 반환함\n"), _c('br'), _vm._v(" ※ 환불시 10원 미만은 절사함")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강 후 재료비는 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("•개강 중 중간신청자도 강좌개강일 시점으로 동일한 환불기준이 적용됨")]), _vm._v(" "), _c('li', [_vm._v("•신용카드 결제 신청자의 개강 후 환불은 카드사에서 부분 취소 후 무통장 입금(계좌이체)으로 환불")]), _vm._v(" "), _c('li', [_vm._v("- 개강 전 취소는 100% 환불(카드 취소)")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 일부 환불은 환불 신청자 명의 계좌로 무통장 입금")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("성동50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 홈페이지 [로그인] → [마이페이지] → [내강좌] → [수강확인] 및 취소")]), _vm._v(" "), _c('li', [_vm._v("• 수강생 명과 본인 명의의 계좌번호/은행 입력 (※카드결제의 경우도 계좌번호 작성해야 함)")]), _vm._v(" "), _c('li', [_vm._v("• 환불 신청일로부터 2주 이내 환불처리")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("수업을 할 수 없거나, 수업 장소를 제공할 수 없게 된 날")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비를 일할 예산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월 이내인 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("총 수업시간의 1/2 경과 후")]), _vm._v(" "), _c('td', [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("학습비 징수기간이"), _c('br'), _vm._v("1개월을 초과하는 경우")]), _vm._v(" "), _c('td', [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("수업시작 후")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1일 특강 및 단기 특강")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("개강일 이전까지만 전액 환불 가능")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("비고")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1. “학습비 징수기간”이란 징수된 총학습비에 따른 총수업일을 말한다.\n"), _c('br'), _vm._v("2. “총수업시간”이란 학습비 징수기간 중의 총수업시간(회차)를 말한다.\n"), _c('br'), _vm._v("3. 반환금액의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로 한다.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 수강취소는 '[마이페이지] - [내강좌]' 메뉴에서 진행가능")]), _vm._v(" "), _c('li', [_vm._v("• 개강일 이후 재료비 및 교재비 등은 환불 불가")]), _vm._v(" "), _c('li', [_vm._v("• 수강취소일 기준은 실제 수강여부와 무관하게 수강취소를 진행한 해당일 기준")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("강북50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「평생교육법 시행령(제23조제2항) 학습비 반환기준 및 소비자분쟁해결기준」")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•환불 신청 방법")]), _vm._v(" "), _c('li', [_vm._v("- 홈페이지 로그인 → 마이페이지 → 내 강좌 → 수강 확인 및 취소 ")]), _vm._v(" "), _c('li', [_vm._v("- 수강생 명과 예금주의 계좌번호 / 은행 입력 (※ 카드결제경우에도 계좌번호 작성 必)")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 수강 취소 시 교재비, 재료비는 환불 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•학습비 징수기간 : 징수된 총 학습비에 따른 총 수업일")]), _vm._v(" "), _c('li', [_vm._v("•총 수업시간: 장수기간 중의 총 수업시간")]), _vm._v(" "), _c('li', [_vm._v("•반환금액 산정은 반환사유가 발생한 날까지 경과된 수업일 기준")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col",
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("1. 법 제28조 제 4항 제1호 및 제2호에 따른 반환사유의 경우")]), _vm._v(" "), _c('td', [_vm._v("수업을 할 수 없거나 수업장소를 제공할 수 없게 된 날 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습단위를 일 단위로 계산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v("2. 법 제 28조 제4항 제3호에 따른 반환사유의 경우")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("가. 학습비 징수기간이"), _c('br'), _vm._v("1개월 이내인 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(" 1) 수업시작 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2)　총 수업시간의 1/3 경과 전")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 2/3 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3) 총 수업시간의 1/2 경과 전 ")]), _vm._v(" "), _c('td', [_vm._v("이미 낸 학습비의 1/2 해당 금액")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4) 총 수업시간의 1/2 경과 후")]), _vm._v(" "), _c('td', [_vm._v("반환하지 아니함")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("나. 학습비 징수기간이 1개월을 초과하는 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("1) 수업시작 전")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("이미 낸 학습비 전액")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("2) 수업시작 후")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("환불요청일 당해 월의 반환 학습비(학습비 징수기간이 1개월 이내인 경우에 준하여 산출된 학습비를 말한다)와 나버지 잔여달(잔여회차)의 학습비 전액을 합산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("환불 기준")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("- 수강취소일 기준: 실제 수강여부와 무관하게 수강취소를 진행한 해당일 기준\n"), _c('br'), _vm._v("- 온라인 상 환불요청일자를 취소일로 계산하고 원단위 절사 ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- 폐강으로 인한 환불대상자는 전화상담 후 환불처리")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 수강 취소 시 교재비, 재료비는 환불 불가")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-area-box__section-title center",
    staticStyle: {
      "color": "#1E8732"
    }
  }, [_vm._v("용산50플러스센터")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("※근거")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「서울특별시 용산구 중장년층 인생이모작 지원에 관한 조례」 제8조(사용료 등)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 신청 방법")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•환불 신청 방법")]), _vm._v(" "), _c('li', [_vm._v("- 홈페이지 로그인 → 마이페이지 내 수강확인 및 취소신청 → 담당자 확인 → 환불 처리(신청일로부터 2주 이내, 카드결제인 경우 카드 (부분)취소 처리/무통장입금의 경우 본인 명의 계좌로 환급)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 환불 기준")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("•개강일 이전은 전액 환급되며, 개강일 이후는 남은 기간을 산정하여 수강료가 환급")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("환불기준 표")]), _vm._v(" "), _c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col",
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환사유 발생일")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background": "#006ffb !important"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("반환금액")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" 1. 제8조제3항제1호 및 제2호에 따른 반환 사유의 경우")]), _vm._v(" "), _c('td', [_vm._v("수업을 할 수 없거나, 수업 장소를 제공할 수 없게 된 날")]), _vm._v(" "), _c('td', [_vm._v("수강료를 일 단위로 계산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v("2. 제8조 제3항 제3호에 따른  반환 사유의 경우")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("가. 수강료 징수기간이 1개월 이내인 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수업 시작 전")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수강료 전액")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("총 수업시간의 1/3이 지나기 전")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수강료의 2/3 해당액")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("총 수업시간의 1/3이 지난 후부터 1/2이 지나기 이전까지 ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수강료의 1/2 해당액")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("총 수업시간의 1/2이 지난 후")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수강료 미반환")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("나. 수강료 징수기간이 1개월을 초과하는 경우")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수업시작 전")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수강료 전액")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("수업시작 이후")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("반환 사유가 발생한 그 달의 반환대상 수강료(수강료 징수기간이 1개월 이내인 경우에 준하여 산출된 수강료를 말한다)와 나머지 달의 수강료 전액을 합산한 금액")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("비  고")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" 총 수강시간은 프로그램 신청기간 중 공고한 총 수강시간을  말하며, 반환금의 산정은 반환사유가 발생한 날까지 경과된 수업시간을 기준으로 한다.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 유의 사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("- 환불액 산정은 반환 사유가 발생한 날까지를 경과된 수업 시간으로 책정함 즉, 학습 포기 의사를 밝힌 날의 다음 날부터 계산하여 반환함 (단, 학습 포기 의사를 밝힌 날은 실제 수강 여부와 상관없이 홈페이지에서 수강취소를 진행한 해당일로 봄)")]), _vm._v(" "), _c('li', [_vm._v("- 환불시 10원 미만은 절사함")]), _vm._v(" "), _c('li', [_vm._v("- 센터의 지정 은행 외 타 은행 계좌환불 요청 시 수수료는 수강생이 직접 부담하며 개강 후 재료비 및 교재비는 환불 불가능"), _c('br'), _vm._v("• 수수료 발생 부분: 타 은행 계좌 이체 시 수수료, 카드 취소 시 발생하는 사업자 수수료")]), _vm._v(" "), _c('li', [_vm._v("- 개강 후 중간에 신청했을 때도 강좌 개강일 시점으로 동일한 환불 기준을 적용")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-input-group clearfix",
    attrs: {
      "tabIndex": "0"
    }
  }, [_c('div', {
    staticClass: "text-area-box",
    attrs: {
      "id": "photo-agree"
    }
  }, [_c('label', {
    staticClass: "block-input-label",
    attrs: {
      "for": "photo-agree"
    }
  }, [_vm._v("사진 및 영상촬영 동의")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("교육 시 사진 및 영상촬영을 진행할 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("해당 촬영결과물은 언론보도자료 또는 행사기록용 등이 비영리목적으로만 활용됩니다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "block-input-label",
    attrs: {
      "for": "photo-agree"
    }
  }, [_vm._v("온라인 교육 등에 따른 강의자료(영상) 무단 복제 및 배포 금지")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("※ 위반 시 저작권법(제18조, 20조, 22조, 136조)에 의거, 모든 책임은 본인에게 있습니다.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-456a2b51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/education/CourseForm.vue
// module id = 1375
// module chunks = 6